import { Reducer } from 'redux';
import { CentrosDistribuicaoState, CentrosDistribuicaoTypes } from './types';

const INITIAL_STATE: CentrosDistribuicaoState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<CentrosDistribuicaoState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CentrosDistribuicaoTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CentrosDistribuicaoTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case CentrosDistribuicaoTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case CentrosDistribuicaoTypes.CLEAN_MOVIENTRADA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
